// extracted by mini-css-extract-plugin
export default {"root_image_inner":"advertisementForm_root_image_inner__uTq7v","formTabs_root":"advertisementForm_formTabs_root__XVzdi"};